// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__2TGIo","radioRow":"SimpleQuestionBuilderModal_radioRow__1c9M4"};